module.exports = __webpack_public_path__ + "static/media/aboutBg1900.22567a0a.png";